


// import React from 'react';
// import { FaUser, FaEnvelope, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';
// import contactImage from '../assets/CImg.png'; // Update with your actual image path

// const ContactForm = () => {
//   return (
//     <div className="flex flex-col md:flex-row items-center justify-center min-h-screen bg-gray-50 p-4 gap-8">
//       {/* Top (Mobile) or Left (Desktop): Image */}
//       <div className="w-full md:w-1/3 p-4">
//         <img src={contactImage} alt="Contact" className="w-full h-full rounded-lg object-cover border" />
//       </div>

//       {/* Bottom (Mobile) or Right (Desktop): Form */}
//       <div className="w-full md:w-1/3 bg-white p-8 rounded-lg shadow-lg">
//         <h2 className="text-center text-lg font-semibold text-gray-700 mb-6">
//           Fill out the form below and we shall get in touch with you.
//         </h2>
//         <form className="space-y-4">
//           <div className="relative">
//             <input
//               type="text"
//               placeholder="Your name"
//               className="w-full border border-gray-300 rounded-md pl-10 py-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#FF9630]"
//             />
//             <span className="absolute left-3 top-3 text-gray-400">
//               <FaUser />
//             </span>
//           </div>
//           <div className="relative">
//             <input
//               type="email"
//               placeholder="Email Address"
//               className="w-full border border-gray-300 rounded-md pl-10 py-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#FF9630]"
//             />
//             <span className="absolute left-3 top-3 text-gray-400">
//               <FaEnvelope />
//             </span>
//           </div>
//           <div className="relative">
//             <input
//               type="text"
//               placeholder="Mobile No"
//               className="w-full border border-gray-300 rounded-md pl-10 py-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#FF9630]"
//             />
//             <span className="absolute left-3 top-3 text-gray-400">
//               <FaPhone />
//             </span>
//           </div>
//           <div className="relative">
//             <input
//               type="text"
//               placeholder="Location where interested"
//               className="w-full border border-gray-300 rounded-md pl-10 py-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#FF9630]"
//             />
//             <span className="absolute left-3 top-3 text-gray-400">
//               <FaMapMarkerAlt />
//             </span>
//           </div>
//           <div className="flex items-center space-x-2 border border-gray-300 p-1 pl-3 rounded-md">
//             <input type="checkbox" className="w-4 h-8" />
//             <label className="text-gray-600">I'm not a robot</label>
//           </div>
//           <button
//             type="submit"
//             className="w-full bg-[#FF9630] text-white font-medium py-2 rounded-md hover:bg-orange-600 transition duration-200"
//           >
//             SUBMIT
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default ContactForm;

import React, { useState } from 'react';
import { FaUser, FaEnvelope, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';
import contactImage from '../assets/CImg.png'; // Update with your actual image path

const ContactForm = () => {
  // Initialize form data with dummy JSON structure
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    location: '',
    isRobot: false,
  });

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    // Use FormData to submit the form data
    const formSubmission = new FormData();
    for (const key in formData) {
      formSubmission.append(key, formData[key]);
    }

    // Log the form data for demonstration (replace with actual API call)
    for (const pair of formSubmission.entries()) {
      console.log(`${pair[0]}: ${pair[1]}`);
    }

    alert('Form submitted successfully!');
  };

  return (
    <div className="flex flex-col md:flex-row items-center justify-center min-h-screen bg-gray-50 p-4 gap-8">
      {/* Top (Mobile) or Left (Desktop): Image */}
      <div className="w-full md:w-1/3 p-4">
        <img src={contactImage} alt="Contact" className="w-full h-full rounded-lg object-cover border" />
      </div>

      {/* Bottom (Mobile) or Right (Desktop): Form */}
      <div className="w-full md:w-1/3 bg-white p-8 rounded-lg shadow-lg">
        <h2 className="text-center text-lg font-semibold text-gray-700 mb-6">
          Fill out the form below and we shall get in touch with you.
        </h2>
        <form className="space-y-4" onSubmit={handleSubmit}>
          <div className="relative">
            <input
              type="text"
              name="name"
              placeholder="Your name"
              value={formData.name}
              onChange={handleInputChange}
              className="w-full border border-gray-300 rounded-md pl-10 py-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#FF9630]"
            />
            <span className="absolute left-3 top-3 text-gray-400">
              <FaUser />
            </span>
          </div>
          <div className="relative">
            <input
              type="email"
              name="email"
              placeholder="Email Address"
              value={formData.email}
              onChange={handleInputChange}
              className="w-full border border-gray-300 rounded-md pl-10 py-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#FF9630]"
            />
            <span className="absolute left-3 top-3 text-gray-400">
              <FaEnvelope />
            </span>
          </div>
          <div className="relative">
            <input
              type="text"
              name="phone"
              placeholder="Mobile No"
              value={formData.phone}
              onChange={handleInputChange}
              className="w-full border border-gray-300 rounded-md pl-10 py-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#FF9630]"
            />
            <span className="absolute left-3 top-3 text-gray-400">
              <FaPhone />
            </span>
          </div>
          <div className="relative">
            <input
              type="text"
              name="location"
              placeholder="Location where interested"
              value={formData.location}
              onChange={handleInputChange}
              className="w-full border border-gray-300 rounded-md pl-10 py-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#FF9630]"
            />
            <span className="absolute left-3 top-3 text-gray-400">
              <FaMapMarkerAlt />
            </span>
          </div>
          <div className="flex items-center space-x-2 border border-gray-300 p-1 pl-3 rounded-md">
            <input
              type="checkbox"
              name="isRobot"
              checked={formData.isRobot}
              onChange={handleInputChange}
              className="w-4 h-8"
            />
            <label className="text-gray-600">I'm not a robot</label>
          </div>
          <button
            type="submit"
            className="w-full bg-[#FF9630] text-white font-medium py-2 rounded-md hover:bg-orange-600 transition duration-200"
          >
            SUBMIT
          </button>
        </form>
      </div>
    </div>
  );
};

export default ContactForm;
